import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-information',
  templateUrl: 'pap-information.component.html',
  styleUrls: ['./pap-information.component.less', '../../../shared/common.less'],
})

export class PapInformationComponent implements OnInit {
  @Input() venue: ElectionVenue;
  @Output() venueChange = new EventEmitter<ElectionVenue>();

  needPap: boolean = undefined;

  constructor() {}
  
  onVenueChange() {
    this.venueChange.emit(this.venue);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  
  ngOnInit(): void {
  }
}
